import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLocationData, uploadImageRequest } from '../../../../store/actions/location';
export const useUploadFloorFile = () => {
    const dispatch = useDispatch();
    const location_data = useSelector((state) => state.location.location_data);
    return useCallback((file, floorImageId, floorKey, isEditFloorMap = false) => {
        if (location_data?.action_type === 'edit' && floorKey === undefined && floorImageId === undefined) {
            dispatch(setLocationData({ ...location_data, editNewFloorUpdated: true }));
        }
        dispatch(uploadImageRequest({ file, floorImageId, floorKey }));
    }, []);
};